import React from "react";
import { ListGroup, Row, Col } from "react-bootstrap";
import DeleteIcon from "./Inputs/DeleteIcon";
import CustomAvatar from "./ui/CustomAvatar";
import DeleteModel from './modals/DeleteModel';
import he from 'he';

function ListItems({
  items,
  onDelete,
  onEdit,
  titleField = "title",
  descriptionField = "description",
  dateField = "created_at",
  avatarField = "created_by",
  noItemsMessage = "No items to display",
}) {
  const [showDeleteModal, setShowDeleteModal] = React.useState(false);
  const [itemToDelete, setItemToDelete] = React.useState(null);

 const confirmDelete = (id) => {
    setItemToDelete(id);  
    setShowDeleteModal(true);
  };

  const handleDelete = () => {
    if (itemToDelete) {
      onDelete(itemToDelete); 
      setShowDeleteModal(false);
      setItemToDelete(null);
    }
  };


  return (
    <>
      {items.length > 0 ? (
        <ListGroup
          className="p-4 primary-box border-top-0 rounded-bottom-4"
        >
         {[...items]
         .sort((a, b) => new Date(b[dateField]) - new Date(a[dateField])) // Sort by latest date
         .map((item) => (
            <ListGroup.Item
              key={item.id}
              className="rounded-4 secondary-box m-1 p-3"
              onClick={() => onEdit(item)}
              style={{
                cursor: "pointer",
              }}
            >
              <Row className="d-flex align-items-start justify-content-between">
                {/* Avatar, Title, Date, Delete Row */}
                <Col className="d-flex align-items-center gap-4">
                  {/* Avatar */}
                  <CustomAvatar user={item[avatarField]} size="35px" fontSize={20} />

                  {/* Title and Date */}
                  <div>
                    <h6 className="mb-0 p2 fw-semibold text-truncate">
                      {item[titleField].charAt(0).toUpperCase() + item[titleField].slice(1)}
                    </h6>
                    <p className="text-muted mb-0 p4" >
                      ({(() => {
                        const formattedDate = new Date(item[dateField]);
                        const year = formattedDate.getFullYear();
                        const month = String(formattedDate.getMonth() + 1).padStart(2, "0");
                        const day = String(formattedDate.getDate()).padStart(2, "0");
                        const hours = String(formattedDate.getHours()).padStart(2, "0");
                        const minutes = String(formattedDate.getMinutes()).padStart(2, "0");

                        return `${year}-${month}-${day} ${hours}:${minutes}`;
                      })()})
                    </p>
                  </div>
                </Col>

                {/* Delete Icon */}
                <Col xs="auto" className="d-flex align-items-center px-0">
                  <DeleteIcon
                    size={14}
                    id={item.id}
                    onDelete={() => confirmDelete(item.id)} 
                    className="p-0 m-0"
                  />
                </Col>
              </Row>

              {/* Description (Rich Text) */}
              <Row className="mt-2 px-1">
                <Col>
                  <p
                    className="p4 text-secondary mb-0"
                    style={{
                      whiteSpace: "normal",
                      wordBreak: "break-all",
                    }}
                  />
                  {he.decode(item[descriptionField].replace(/<[^>]+>/g, ""))} {/* Decode HTML entities and remove tags */}
                </Col>
              </Row>
            </ListGroup.Item>
    
          ))}
        </ListGroup>
      ) : (
        <p className="text-muted text-center p-3 p4 p-4 primary-box border-top-0 rounded-bottom-4">{noItemsMessage}</p>
      )}

      
        <DeleteModel
          open={showDeleteModal}
          closeAlert={() => setShowDeleteModal(false)}
          onClick={handleDelete}
        />
    </>
  );
}

export default ListItems;
